// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default () => {
  // const { executeRecaptcha } = useGoogleReCaptcha();
  return {
    recaptcha: /* import.meta.env.VITE_RECAPTCHA_ENTERPRISE_KEY
      ? executeRecaptcha
      : */ true
  };
};
